import { useClientSideDeviceDetection } from "~/utils/device-detection.utils";

import DownloadHero from "./components/DownloadHero";
import styles from "./page.module.scss";

import type { MoreWaysToPlayLinks } from "./types";
import type { DownloadSection } from "~/typings";
import type { Dictionary } from "~/utils/dictionaries";

export function DownloadView({
	downloadSection,
	dict,
	isAltAppstoreEnabled,
	moreWaysToPlayLinks,
	epicClientAndroidInstallerUrl,
}: {
	downloadSection: DownloadSection;
	dict: Dictionary;
	isAltAppstoreEnabled: boolean;
	moreWaysToPlayLinks: MoreWaysToPlayLinks;
	epicClientAndroidInstallerUrl: string;
}): React.ReactNode {
	const { deviceProfile } = useClientSideDeviceDetection();

	if (deviceProfile.os === "ios" && isAltAppstoreEnabled) {
		window.location.href = `https://store.epicgames.com/download/rocket-league-sideswipe`;
		// TODO: show some kind of loader?
	}

	const backgroundImage = downloadSection.backgroundImage?.url;

	return (
		<div className={styles.downloadPageWrapper}>
			<img
				className={styles.backgroundBlur}
				src={backgroundImage!}
				width={1920}
				height={1080}
				alt={downloadSection.backgroundImage?.title ?? ""}
			/>
			<DownloadHero
				content={downloadSection}
				dict={dict}
				moreWaysToPlayLinks={moreWaysToPlayLinks}
				isAndroid={deviceProfile.os === "android"}
				epicClientAndroidInstallerUrl={epicClientAndroidInstallerUrl}
			/>
		</div>
	);
}
